/**
 * Skeleton Component
 *
 * ShadCN-style skeleton placeholder for loading states.
 * Renders an animated pulsing div that can be sized via className.
 */

import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
